import React, { useState, useEffect, useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { io } from 'socket.io-client';

/**
 * Displays the event-level signing QR code for the registration station.
 * Candidates scan this with their phone to sign required documents.
 * Shows live notifications as candidates sign in.
 */
export default function SigningQRDisplay({ eventId, signUrl, signCode }) {
  const [recentSigners, setRecentSigners] = useState([]);
  const socketRef = useRef(null);

  useEffect(() => {
    const socket = io({ transports: ['websocket', 'polling'] });
    socketRef.current = socket;
    socket.emit('join_registration', eventId);
    socket.on('candidate:signed', (payload) => {
      setRecentSigners((prev) => [
        { name: payload.printedName, id: Date.now() },
        ...prev.slice(0, 4)
      ]);
    });
    return () => {
      socket.disconnect();
      socketRef.current = null;
    };
  }, [eventId]);

  return (
    <div className="event-qr-panel">
      <div className="event-qr-left">
        <p className="signing-instructions">
          Scan with your phone to review and sign required documents.
        </p>
        <p className="signing-url-text">{signUrl}</p>
        {recentSigners.length > 0 && (
          <ul className="recent-signers-list">
            {recentSigners.map((s) => (
              <li key={s.id} className="signer-notification">
                <span className="signer-check">✓</span> {s.name}
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className="qr-container">
        <QRCodeSVG value={signUrl} size={180} level="M" />
        <p className="qr-code-label">{signCode}</p>
      </div>
    </div>
  );
}
